import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IEventsRepository } from '../../domain/events/i-events-repository';
import { WhatsappEvent } from '../../domain/events/types';

@Injectable({
  providedIn: 'root',
})
export class FakeEventsRepository implements IEventsRepository {
  public connect(_companyPhoneNumber: string): Observable<WhatsappEvent> {
    return new Observable<WhatsappEvent>(() => undefined);
  }
}
